module.exports = __webpack_public_path__ + "static/media/11-item-a.f55b17b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/11-item-a.jpg
// module id = 1195
// module chunks = 33